import { createContext, useState, useCallback, useContext } from "react";

export const AppContext = createContext();
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within AppContextProvider");
  }
  return context;
};

export const AppContextProvider = ({ children }) => {

  const [userData, setUserData] = useState(null);
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Fetch all meetings
  const fetchMeetings = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`https://meeting.srptechs.com/api/meetings`);
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      const data = await res.json();
      const meetingsData = Array.isArray(data) ? data : (data.meetings ?? data.data ?? []);
      setMeetings(meetingsData);
      return meetingsData;
    } catch (err) {
      setError(err.message || "Failed to load meetings.");
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Trigger refresh (increments refreshTrigger)
  const refreshMeetings = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
    fetchMeetings();
  }, [fetchMeetings]);

  const contextValue = {
    userData,
    setUserData,
    loading,
    setLoading,
    // State
    meetings,
    error,
    refreshTrigger,
    // Actions
    fetchMeetings,
    refreshMeetings,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};